import { render, staticRenderFns } from "./default-court-details.vue?vue&type=template&id=f3a9300e&scoped=true&"
import script from "./default-court-details.vue?vue&type=script&lang=js&"
export * from "./default-court-details.vue?vue&type=script&lang=js&"
import style0 from "./default-court-details.vue?vue&type=style&index=0&id=f3a9300e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a9300e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
